module.exports = __webpack_public_path__ + "img/about-us-light.f1bb2abe.png";